export default {
  weatherReport: {
    title: "Meteo",
    labels: {
      forecastUnavailable: "Previsioni non disponibili",
      unavailableDescription: "Previsioni meteo non disponibili per questa partita.",
      unavailableValue: "N/A",
    },
    empty: {
      title: "Nessun report meteo disponibile",
    },
  },
};